// extracted by mini-css-extract-plugin
export default {"personalFormContainer":"FormContainer_personalFormContainer__Bwc-Z","formTitle":"FormContainer_formTitle__ggwYd","titleBorder":"FormContainer_titleBorder__jXTmO"};